// import { useResponsive } from 'src/hooks/use-responsive';
// import Box from '@mui/material/Box';
// import PropTypes from 'prop-types';
// import { useSettingsContext } from 'src/components/settings';

// const Logo = ({ sx }) => {
//   const lgUp = useResponsive('up', 'lg');
//   const settings = useSettingsContext();

//   const isNavMini = settings.themeLayout === 'mini';

//   const isNavHorizontal = settings.themeLayout === 'horizontal';

//   let width;
//   let height;

//   if (isNavMini) {
//     width = 60;
//     height = 40;
//   } else if (isNavHorizontal) {
//     width = 140;
//     height = 40;
//   } else {
//     width = 160;
//     height = 80;
//   }

//   console.log('isNavMini in Logo:', isNavMini); // Check the value
//   console.log('Current layout:', settings.themeLayout);
//   console.log('lgUp:', lgUp);

//   return (
//     <Box
//       component="img"
//       src={isNavMini ? './assets/MeruDeskShort.png' : './assets/MeruDesk.png'}
//       alt="Logo"
//       sx={{
//         width,
//         height,
//         cursor: 'pointer',
//         display: 'inline-flex',
//         marginLeft: lgUp && !isNavMini ? 2.5 : 0,
//         ...sx,
//       }}
//     />
//   );
// };

// Logo.propTypes = {
//   sx: PropTypes.object,
// };

// export default Logo;

import PropTypes from 'prop-types';
import { forwardRef, useEffect, useMemo, useState } from 'react';
// @mui
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import axiosInstance from 'src/api/axiosInstance';
import { getAssetUrl } from 'src/utils/domainContext';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, variant = 'full', sx, ...other }, ref) => {

  const token = sessionStorage.getItem('token');

  const [logoPaths, setLogoPaths] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {};
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }
        const response = await axiosInstance.get(
          `/rest/preferences/logoPaths`,
          {
            headers,
          }
        );

        if (response.status === 200) {
          const preferences = Array.isArray(response.data) ? response.data : [response.data];
          const preference =
            preferences.find((item) => item?.logoPath) || preferences[0] || null;
          const logoPath1 = preference?.logoPath || '';

          // Extract only preferencesId and candidateInterviewTime
          const selectedPreferences = {
            preferencesId: preference?.preferencesId,
            candidateInterviewTime: preference?.candidateInterviewTime,
          };
          // Save the extracted properties to sessionStorage
          sessionStorage.setItem('selectedPreferences', JSON.stringify(selectedPreferences));
          localStorage.setItem('selectedPreferences', JSON.stringify(selectedPreferences));
          setLogoPaths(logoPath1);
        } else {
          console.error('Failed to fetch logo paths:', response.statusText);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, [token]);


  const fallbackLogoSrc = useMemo(
    () =>
      variant === 'short'
        ? getAssetUrl('/assets/MeruDeskShort.png')
        : getAssetUrl('/assets/MeruDesk.png'),
    [variant]
  );

  const currentLogoSrc = useMemo(
    () => logoPaths || fallbackLogoSrc,
    [logoPaths, fallbackLogoSrc]
  );

  const mergedSx = useMemo(() => {
    const isShort = variant === 'short';
    const hasCustomLogo = !!logoPaths;

    const baseSx = {
      width: isShort ? 'auto' : '100%',
      height: 'auto',
      maxWidth: isShort ? 54 : 200,
      maxHeight: isShort ? 40 : 80,
      objectFit: 'contain',
      objectPosition: isShort ? 'center' : 'left center',
      margin: isShort ? '0 auto' : '0',
      cursor: 'pointer',
      display: 'block',
    };

    const layoutSx = { ...sx };

    if (hasCustomLogo) {
      if (layoutSx.height === 32 && layoutSx.width === 'auto') {
        delete layoutSx.height;
        delete layoutSx.width;
        layoutSx.maxWidth = isShort ? 54 : 220;
        layoutSx.maxHeight = isShort ? 36 : 45;
      }
    }

    return {
      ...baseSx,
      ...layoutSx,
    };
  }, [sx, variant, logoPaths]);

  const logo = (
    <Box
      ref={ref}
      component="img"
      src={currentLogoSrc}
      alt="Logo"
      sx={mergedSx}
      {...other}
    />
  );


  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/dashboard" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  variant: PropTypes.oneOf(['full', 'short']),
  sx: PropTypes.object,
};

export default Logo;
